import { render, staticRenderFns } from "./designDetails.vue?vue&type=template&id=03a63dfc&scoped=true&"
import script from "./designDetails.vue?vue&type=script&lang=js&"
export * from "./designDetails.vue?vue&type=script&lang=js&"
import style0 from "./designDetails.vue?vue&type=style&index=0&id=03a63dfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a63dfc",
  null
  
)

export default component.exports